const METERS_TO_YARDS = 1.0936132983377078;
const METERS_TO_FEET = 3.280839895013123;
const METERS_PER_SECOND_TO_MPH = 2.2369362920544;

export const Units = {
  metersToYards(meters: number): number {
    return meters * METERS_TO_YARDS;
  },

  yardsToMeters(yards: number): number {
    return yards / METERS_TO_YARDS;
  },

  metersToFeet(meters: number): number {
    return meters * METERS_TO_FEET;
  },

  metersPerSecondToMph(metersPerSecond: number): number {
    return metersPerSecond * METERS_PER_SECOND_TO_MPH;
  },

  formatYards(meters: number, fractionDigits = 0): string {
    return `${this.metersToYards(meters).toFixed(fractionDigits)} yd`;
  },
};
